import React from 'react'
import PropTypes from 'prop-types'

import Logo from '../components/Logo'

import './NavBar.css'

const NavBar = ({ children, title, tools }) => (
    <div className="navbar navbar-default navbar-fixed-top be-top-header">
        <div className="navbar-header">
            <Logo />
        </div>
        <div className="be-right-navbar">
            <div className="page-title">
                { title }
            </div>
            <div className="navbar-tools">
                { tools }
            </div>
            { children }
        </div>
    </div>
)

NavBar.propTypes = {
    title : PropTypes.node,
    tools : PropTypes.node
}

export default NavBar
